import { c as _c } from "react/compiler-runtime";
import { Box } from '@mui/material';
import { useCreditCardCompareOfferContext } from '../OfferContext';
import { ContentText } from './components/ContentText';
import { ProsContainer } from './Pros.container';
export function Pros() {
  const $ = _c(4);
  const {
    offer: t0
  } = useCreditCardCompareOfferContext();
  const {
    prosBullets
  } = t0;
  let t1;
  if ($[0] !== prosBullets) {
    t1 = prosBullets.length > 0 ? prosBullets.map(_temp) : "-";
    $[0] = prosBullets;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <ProsContainer>{t1}</ProsContainer>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}
function _temp(proBullet, proBulletIndex) {
  return <Box key={proBulletIndex} display="flex" flexDirection="row"><Box aria-hidden="true" component="span" data-testid="CheckIcon" className="mask-icon mask-icon-check" sx={{
      width: {
        xs: "1rem",
        md: "1.5rem"
      },
      height: {
        xs: "1rem",
        md: "1.5rem"
      },
      mr: 2,
      backgroundColor: "primary.main",
      flexShrink: 0
    }} /><ContentText>{proBullet}</ContentText></Box>;
}